import * as React from 'react';
import {
  Component,
  I18NString,
  checkFileExtension,
  getFiletExtension,
  Guid,
} from '../../Utils';
import {
  remove,
  isEmpty,
  findIndex,
  isUndefined,
  filter,
  reverse,
  assign,
} from 'lodash';
import { IControlError, IControlSchema } from '../../Controls';
import { IDispatcher } from '../extensions/Dispatcher';
import { File, IFileProps } from './File';
import Field from '../Field';
import Alert from './Alert';
import { isNull, isNullOrUndefined } from 'util';
import { Dictionary } from '../../../types/Dictionary';
import { Simulate } from 'react-dom/test-utils';
import input = Simulate.input;

const style = { margin: '0 0 10px 0' };

interface Props {
  field: any;
  defaultValue: any;
  dispatcher: IDispatcher;
  onSave: any;
  row: any;
  file_formats: Array<string>;
  schema?: any;
  // error: IControlError | undefined;
}

interface FileValueItem {
  id: string;
  value: string;
  url: string;
  isLoader: boolean;
}

interface State {
  inputs: Array<FileValueItem>;
  isComment: boolean;
  comment: string;
  showHelp: boolean;
  warningDesc: string;
}

interface CheckBoxProps {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextArea = ({ onChange, onBlur, value, disabled }) => {
  return (
    <textarea
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      className="form-control"
      placeholder="Комментарий"
    />
  );
};

const CheckBox = ({ label, onChange, checked, disabled }: CheckBoxProps) => (
  <div className="checkbox">
    <label htmlFor="ch">
      <input
        disabled={disabled}
        onChange={onChange}
        type="checkbox"
        name="ch"
        checked={checked}
      />
      {label}
    </label>
  </div>
);

const isExist = (inputs: Array<FileValueItem>) => {
  if (inputs.length > 0) {
    for (let input of inputs) {
      if (input.url !== null || input.isLoader) return true;
    }
  }

  return false;
};

const isLoader = (inputs: Array<FileValueItem>) => {
  if (inputs !== null && inputs.length > 0) {
    for (let input of inputs) {
      if (input.isLoader) return true;
    }
  }

  return false;
};

const createEmtyInput = () => {
  return { id: Guid.newGuid(), value: null, url: null, isLoader: false };
};

export default class GridMultipleFiles extends Component<Props, State> {
  public value: any;

  constructor(props) {
    super(props);
    this.state = {
      inputs: [createEmtyInput()],
      isComment: false,
      comment: '',
      showHelp: false,
      warningDesc: '',
    };
    this.value = null;
    this.onAdd = this.onAdd.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onUpload = this.onUpload.bind(this);
    this.onBlurComment = this.onBlurComment.bind(this);
    this.onChangeComment = this.onChangeComment.bind(this);
    this.onClickHelp = this.onClickHelp.bind(this);
  }

  onAdd() {
    let id = Guid.newGuid();
    this.setState({
      inputs: [
        { id, value: null, url: null, isLoader: false },
        ...this.state.inputs,
      ],
    });
  }

  onChange(e: React.ChangeEvent<HTMLInputElement>) {
    let comment = this.state.comment;

    console.log('onChange', this.state);

    // if(!e.target.checked){
    //     this.props.dispatcher.onBlur(this.props.schema.id, null, true, undefined);
    //     comment = '';
    // }
    //
    // this.setState({
    //     isComment:  e.target.checked,
    //     comment
    // });
  }

  onBlurComment() {
    // if(!isEmpty(this.state.comment))
    //     this.props.dispatcher.onBlur(this.props.schema.id,
    //                     this.toJSON(this.state, this.state.inputs),
    //                     true,
    //                     undefined);
    // else
    //     this.props.dispatcher.onBlur(this.props.schema.id, null, true, undefined);
  }

  onChangeComment(e) {
    this.setState({
      comment: e.target.value,
    });
  }

  toJSON(state: State, inputs: Array<any>) {
    let inputsData = filter(inputs, (obj) => obj.url !== null).map((obj) => {
      return {
        id: obj.id,
        url: obj.url,
        value: obj.value,
      };
    });

    if (state.isComment) {
      return { isComment: state.isComment, comment: state.comment, inputs: [] };
    } else {
      return inputsData.length > 0
        ? JSON.stringify({
            isComment: state.isComment,
            comment: state.comment,
            inputs: inputsData,
          })
        : '';
    }
  }

  onRemove(el: FileValueItem, e: React.ChangeEvent<HTMLInputElement>) {
    let loaders = [...this.state.inputs];
    const idx = findIndex(loaders, (o) => o.id === el.id);
    let inputs = remove(
      this.state.inputs,
      (o: FileValueItem) => o.id !== el.id,
    );
    let self = this;

    if (el.url !== null) {
      loaders[idx].isLoader = true;
      self.setState({ inputs: loaders });
      // TODO: Need to check
      console.log('GridMultipleFiles need to check');
      this.props.dispatcher.deleteFileValue(
        this.props.field.field,
        el.value,
        self.toJSON(self.state, inputs),
        el.id,
        {
          success: () => {
            // self.props.dispatcher.onLoadFile(el.id, inputs.length > 0 ?
            //     {...this.state, inputs,  error:null} : null
            // );
            if (inputs.length === 0) {
              inputs.push(createEmtyInput());
            }
            self.setState({
              inputs,
            });
            this.value = JSON.stringify(inputs);

            const filterValues = inputs.filter((value) => value.value !== null);
            if (typeof this.props.row !== 'undefined') {
              if (filterValues.length > 0) {
                this.props.row[this.props.field.field] =
                  JSON.stringify(filterValues);
              } else {
                this.props.row[this.props.field.field] = null;
              }
              this.props.onSave(this.props.row);
            }
          },
        },
      );
    } else {
      if (inputs.length === 0) {
        // self.props.dispatcher.onLoadFile(el.id, null);
        inputs.push(createEmtyInput());
      }
      self.setState({
        inputs,
      });
      this.value = JSON.stringify(inputs);
    }
  }

  onUpload(id: string, e: React.ChangeEvent<HTMLInputElement>) {
    const inputs = [...this.state.inputs];
    const format = ['DOC', 'DOCX', 'PDF', 'PNG', 'JPG', 'JPEG', 'ZIP', 'RAR'];
    const { files: _files } = e.target;
    const idx = findIndex(inputs, (o) => o.id === id);
    if (_files.length === 0) return;

    const filename = _files[0].name;
    const options = {
      id: this.props.field.field,
      maxSize: 0,
      format: 'PDF',
      element: e.target,
    };

    if (
      idx > -1 &&
      checkFileExtension(filename, format) &&
      _files[0].size <= 10485760
    ) {
      inputs[idx].value = filename;
      // TODO: Need to check
      console.log('GridMultipleFiles need to check');
      inputs[idx].url = this.props.dispatcher.getFileUrl(id, 'document');
      inputs[idx].isLoader = true;

      this.setState({ inputs });
      this.props.dispatcher.setFileValue(
        options,
        this.toJSON(this.state, inputs),
        id,
        {
          success: (response) => {
            inputs[idx].value = response.name;
            inputs[idx].url = this.props.dispatcher.getFileUrl(id, 'document');
            inputs[idx].isLoader = false;

            // this.props.dispatcher.onLoadFile(this.props.field.field, {...this.state, error:null});
            this.setState({
              inputs,
              warningDesc: '',
            });
            this.value = JSON.stringify(inputs);

            if (typeof this.props.row !== 'undefined')
              this.props.row[this.props.field.field] = this.value;
            this.props.onSave(this.props.row);
            // this.props.dispatcher.setError(this.props.field.field, undefined, undefined, true);
          },
        },
      );
    } else {
      let msg = '';
      if (!checkFileExtension(filename, this.props.file_formats))
        msg = `Неверный формат файла: ${getFiletExtension(filename)}`;
      else if (_files[0].size > 10485760)
        msg = 'Размер файла превышает допустимый размер в 10 мб';

      this.setState({
        warningDesc: msg,
      });
      // this.props.dispatcher.setError(this.props.field.field, undefined, { message: msg }, true);
    }
  }

  createInputFile(isMain: boolean, el: FileValueItem, showButtons) {
    const disabled = false;
    const options = {
      ...this.props,
      ...el /*,  disabled:this.props.schema.disabled*/,
    };

    return (
      <div className="input-group" style={style} key={`File.${el.id}`}>
        <File {...options} onChange={this.onUpload} />
        <span className="input-group-btn">
          {/*<button type="button" onClick={this.onClickHelp} className="btn btn-default btn-add btn-circle">*/}
          {/*    <span className="glyphicon glyphicon-question-sign" />*/}
          {/*</button>*/}
          {showButtons && isMain && (
            <button
              disabled={disabled}
              title="Добавить еще"
              type="button"
              className="btn btn-default btn-add"
              onClick={this.onAdd}
            >
              <span className="glyphicon glyphicon-plus-sign" />
            </button>
          )}
          {showButtons && isMain && el.value !== null && (
            <button
              disabled={disabled}
              type="button"
              className="btn btn-danger btn-remove"
              onClick={(e: any) => this.onRemove(el, e)}
            >
              Удалить
            </button>
          )}
          {showButtons && !isMain && (
            <button
              disabled={disabled}
              type="button"
              className="btn btn-danger btn-remove"
              onClick={(e: any) => this.onRemove(el, e)}
            >
              Удалить
            </button>
          )}
        </span>
      </div>
    );
  }

  componentDidMount() {
    const { defaultValue, field } = this.props;
    const { inputs } = this.state;
    const values = JSON.parse(defaultValue);

    if (!isNullOrUndefined(inputs)) {
      if (!values || values.length === 0) {
        this.setState({ inputs });
        this.value = JSON.stringify(inputs);
      } else {
        this.setState({ inputs: [...values] });
        this.value = JSON.stringify(values);
      }
    }
    if (
      typeof this.props.schema.extra !== 'undefined' &&
      this.props.schema.extra.showHelp
    ) {
      this.setState({ showHelp: true });
    }
  }

  onClickHelp() {
    this.setState({ showHelp: !this.state.showHelp });
  }

  render() {
    // const { schema: {isEnableComment, disabled}, error } = this.props;

    const isEnableComment = false;

    // const errorMessage = error && error.message;
    const isShowButtons = !isLoader(this.state.inputs);
    const fieldState =
      isExist(this.state.inputs) ||
      (this.state.isComment && this.state.comment !== '')
        ? 'success'
        : 'default';

    // return <div />
    return !this.state.isComment || !isEnableComment ? (
      <div className="notnull">
        {this.state.inputs.map((item: FileValueItem, idx: number) =>
          this.createInputFile(
            idx == this.state.inputs.length - 1,
            item,
            isShowButtons,
          ),
        )}
        {/*{*/}
        {/*    isEnableComment && !isExist(this.state.inputs) && (*/}
        {/*        <CheckBox disabled={disabled} label="Нет файлов?" onChange={this.onChange} checked={this.state.isComment}></CheckBox>*/}
        {/*    )*/}
        {/*}*/}
        {/*{ errorMessage && (<Alert>{errorMessage}</Alert>) }*/}
        {this.state.showHelp && (
          <div className="alert alert-warning" role="alert">
            {/*{ this.props.schema.description && (*/}
            <div>
              {/*<span dangerouslySetInnerHTML={{ __html: this.props.schema.description.ru }}></span>*/}
              <br />
            </div>
            {/*)  } */}
            Допустимые форматы файлов для загрузки:
            {/*this.props.schema.format.join(',') */}.<br />
            Максимальный размер файла не должен превышать 10Мб
          </div>
        )}
        {this.state.warningDesc && (
          <div className="alert alert-warning" role="alert">
            {this.state.warningDesc}
          </div>
        )}
      </div>
    ) : (
      <div className="null" />
      //     <Field {...this.props.schema} status={fieldState} >
      //         <TextArea disabled={disabled} onBlur={this.onBlurComment} onChange={this.onChangeComment} value={this.state.comment}></TextArea>
      //         <CheckBox disabled={disabled} label="Нет файлов?" onChange={this.onChange} checked={this.state.isComment}></CheckBox>
      //         { errorMessage && (<Alert>{errorMessage}</Alert>) }
      //     </Field>
    );
  }
}

export function createGridMultiFiles(
  field,
  defaultValue,
  dispatcher,
  onSave,
  row,
) {
  return (
    <GridMultipleFiles
      field={field}
      defaultValue={defaultValue}
      dispatcher={dispatcher}
      onSave={onSave}
      row={row}
      file_formats={[]}
    />
  );
}
